<template>
  <dropzone-form></dropzone-form>
</template>

<script>
  import DropzoneForm from '../../components/dropzone/DropzoneFormNew.vue'
  export default {
    data () {
      return {
        model: {}
      }
    },
    created () {
    },
    computed: {
    },
    methods: {
    },
    components: {
      'dropzone-form': DropzoneForm
    }
  }
</script>



// WEBPACK FOOTER //
// New.vue?eb2c480e